import { Box, Button, Flex, Image, Input, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { Select } from "antd";
import Loader from "../../Components/Loader/Loader";
import { RelevanceFieldsNew } from "../../Constants/data";
import { Images } from "../../Assets/images";
import FilterToggleButton from "../../Components/Common/FilterToggleButton";
import SellersListModals from "./SellersListModals";
import SellerCard from "./SellerCard";
import useSellersListState from "./useSellersListState";

// Claude: split into useSellersListState.ts (logic) + this file (JSX) 23-03-2026
const BuyerHome = () => {
  const {
    navigate, sellerAsset, filterToggleRef, user,
    relevanceData, setRelevanceData,
    docsModal, handleOpenDocsModal, handleCloseDocsModal, personName, setPersonName,
    sortModal, handleCloseSortModal,
    filterModal, handleCloseFilterModal,
    tagsFilter, handleOpenTagsFilterModal, handleCloseTagsFilterModal,
    interestedTags, selectedTags, setSelectedTags,
    releModal, handleOpenRelevanceModal, handleCloseRelevanceModal,
    orderSort, setOrderSort, relevanceSort, setRelevanceSort,
    notesModal, handleOpenNotesModal, handleCloseNotesModal, notesData, setNotesData,
    meetModal, verifyGateOpen, setVerifyGateOpen, handleOpenMeetModal, handleCloseMeetModal, meetResponder, setMeetResponder,
    accordionActive, setAccordionActive, sellerEvents, setSellerEvents,
    tagsModel, handleOpenTagsModal, handleCloseTagsModal, tagsData, setTagsData,
    meetConfirm, handleOpenMeetConfirmModal, handleCloseMeetConfirmModal, currentMeet, setCurrentMeet,
    search, setSearch, filterCountry, setFilterCountry, filterIndustry, setFilterIndustry,
    countryOptions, industryOptions, inputs, setInputs, event,
    companies, total, hasMore, isFetchingMore, sentinelRef,
    buyerData, meetingData, loading,
    error,
    resetFilters, getSellerCompanies, getAssets, isNewMeetingAllowed,
  } = useSellersListState();

  const RelevanceFilterComponent = () => (
    <Select
      className="custom-select-noborder"
      style={{ width: "100%", border: "0px", outline: "none", height: "100%", fontFamily: '"Inter Variable", sans-serif' }}
      dropdownStyle={{ width: "auto", fontFamily: '"Inter Variable", sans-serif' }}
      onChange={(e) => setRelevanceSort(e)}
      value={relevanceSort}
      dropdownRender={(menu) => <div style={{ lineHeight: 0, margin: 0, padding: 0 }}>{menu}</div>}
      options={[
        { label: "All", value: "" },
        { label: RelevanceFieldsNew.RELEVANT.title, value: RelevanceFieldsNew.RELEVANT.status },
        { label: RelevanceFieldsNew.EXISTING.title, value: RelevanceFieldsNew.EXISTING.status },
        { label: RelevanceFieldsNew.REVIEW.title, value: RelevanceFieldsNew.REVIEW.status },
        { label: RelevanceFieldsNew.NOTRELEVANT.title, value: RelevanceFieldsNew.NOTRELEVANT.status },
      ]}
    />
  );

  return (
    <Box w={"100%"} display={"flex"} flexDirection={"column"} alignItems={"center"} minH={"100dvh"} maxH={"100dvh"} px={"30px"} bg={"body.bg"}>
      {loading && <Loader />}

      <SellersListModals
        navigate={navigate}
        sortModal={sortModal} handleCloseSortModal={handleCloseSortModal} orderSort={orderSort} setOrderSort={setOrderSort}
        meetConfirm={meetConfirm} handleCloseMeetConfirmModal={handleCloseMeetConfirmModal} currentMeet={currentMeet}
        tagsModel={tagsModel} handleCloseTagsModal={handleCloseTagsModal} tagsData={tagsData}
        filterModal={filterModal} handleCloseFilterModal={handleCloseFilterModal} relevanceSort={relevanceSort} setRelevanceSort={setRelevanceSort}
        interestedTags={interestedTags} selectedTags={selectedTags} setSelectedTags={setSelectedTags}
        tagsFilter={tagsFilter} handleCloseTagsFilterModal={handleCloseTagsFilterModal}
        meetModal={meetModal} handleCloseMeetModal={handleCloseMeetModal} meetResponder={meetResponder}
        releModal={releModal} handleCloseRelevanceModal={handleCloseRelevanceModal} relevanceData={relevanceData} reloadData={() => getSellerCompanies(inputs?.event)}
        notesModal={notesModal} handleCloseNotesModal={handleCloseNotesModal} notesData={notesData}
        docsModal={docsModal} handleCloseDocsModal={handleCloseDocsModal} personName={personName} sellerAsset={sellerAsset}
        verifyGateOpen={verifyGateOpen} setVerifyGateOpen={setVerifyGateOpen}
      />

      {/* Claude: Dark header 16-02-2026 */}
      <Flex w={"calc(100% + 60px)"} mx={"-30px"} mt={0} px={"30px"} py={5} bg={"#0E122F"} color={"white"} alignItems={"center"} justifyContent={"space-between"}>
        <Text fontSize={"xl"} fontWeight={700}>Sellers List</Text>
        <VStack spacing={0} alignItems="center" justifyContent="center">
          <Image src={Images.AftrLogo} h="32px" objectFit="contain" />
          <Text fontSize="11px" fontWeight={300} color="whiteAlpha.600" letterSpacing="wide">buyer (beta)</Text>

        </VStack>
      </Flex>

      {/* Claude: search + filter row 26-02-2026 */}
      <VStack w={"100%"} mt={"30px"} spacing={2} alignItems={"end"}>
        <Flex border={"1px solid #E2E8F0"} borderRadius={"10px"} w={"100%"} alignItems={"center"} bg={"white"}>
          <form style={{ width: "100%" }} onSubmit={(e) => { e.preventDefault(); getSellerCompanies(inputs?.event); }}>
            <Input
              placeholder="Seller Company Name" type="text" fontSize="sm"
              _placeholder={{ color: "gray.500", fontWeight: "400", fontSize: "sm" }}
              value={search} onChange={(e) => setSearch(e.target.value)}
              border={"0px"} outline={"none"} _focus={{ outline: "none", border: "0px" }}
              h={"40px"} w={"100%"} px={2} borderColor={"gray.300"}
            />
          </form>
        </Flex>

        <Flex w="100%" gap={2}>
          <Select showSearch style={{ flex: 1, height: "38px" }} options={countryOptions}
            value={filterCountry || undefined} onChange={(val) => setFilterCountry(val || "")}
            onClear={() => setFilterCountry("")} placeholder="Country" allowClear
            filterOption={(input, option) => String(option?.value || "").toLowerCase().includes(input.toLowerCase())}
          />
          <Select showSearch style={{ flex: 1, height: "38px" }} options={industryOptions}
            value={filterIndustry || undefined} onChange={(val) => setFilterIndustry(val || "")}
            onClear={() => setFilterIndustry("")} placeholder="Industry" allowClear
            filterOption={(input, option) => String(option?.label || "").toLowerCase().includes(input.toLowerCase())}
          />
          {event?.length > 0 && (
            <Select style={{ flex: 1, height: "38px" }} value={inputs?.event || undefined}
              onChange={(e) => setInputs({ ...inputs, event: e })} placeholder="Event" allowClear
              onClear={() => setInputs({ ...inputs, event: "" })}
              options={event?.map((ev: any) => ({ label: ev?.eventName, value: ev?._id }))}
            />
          )}
        </Flex>
        <Button onClick={() => getSellerCompanies(inputs?.event)} colorScheme="transparent" variant={"outline"}
          borderColor={"card.borderDark"} w={"60px"} _hover={{ bg: "#2E7D32", color: "white", borderColor: "#2E7D32" }} h={"30px"}>
          <Text fontSize={"sm"} fontWeight={"regular"}>Search</Text>
        </Button>
      </VStack>

      <Flex w={"100%"} justifyContent={"space-between"} flexDirection={"column"}>
        <Text fontSize={"md"} fontWeight={500}>{total} Seller companies found</Text>
        <Text mb={"4px"} fontSize={"xs"} fontWeight={"regular"} color={"text.caption"}>
          Click on company name for more details.<br /> Click on the color icon to change relevance.
        </Text>
        <Flex gap={3} alignItems={"center"} mt={"10px"}>
          <FilterToggleButton
            buttonText="A-Z"
            buttonRef={filterToggleRef as React.LegacyRef<HTMLButtonElement>}
            onClick={() => setOrderSort(orderSort == "z-to-a" ? "a-to-z" : "z-to-a")}
          />
          <Flex bg={"white"} border={"1px solid #D9D9D9"} borderColor={"card.borderLight"} borderRadius={"md"}
            height={"25px"} alignItems={"center"} justifyContent={"center"} padding={"0 5px"}>
            <Text fontWeight={"regular"} fontSize={"xs"}>Relevance</Text>
            <RelevanceFilterComponent />
          </Flex>
          <Button onClick={handleOpenTagsFilterModal} colorScheme="transparent" variant={"outline"}
            borderColor={selectedTags.length ? "primary.main" : "card.borderLight"}
            backgroundColor={selectedTags.length ? "primary.main" : "white"} h={"25px"}>
            <Text fontSize={"xs"} fontWeight={"regular"} color={selectedTags.length ? "secondary.main" : "text.black2"}>Tags</Text>
          </Button>
          <Button variant={"link"} onClick={resetFilters}>
            <Text fontSize={"sm"} fontWeight={"normal"} color={"#006CFF"}>Reset</Text>
          </Button>
        </Flex>
      </Flex>

      <Box w={"100%"} mt={"30px"} h={"100%"} overflowY={"auto"} overflowX={"hidden"} display={"flex"} flexDirection={"column"} gap={"20px"} pb={"100px"}>
        {companies?.map((item: any, index: any) => (
          <SellerCard
            key={"seller_" + index}
            item={item}
            accordionActive={accordionActive} setAccordionActive={setAccordionActive}
            sellerEvents={sellerEvents} setSellerEvents={setSellerEvents}
            meetingData={meetingData} buyerData={buyerData} user={user}
            setRelevanceData={setRelevanceData} handleOpenRelevanceModal={handleOpenRelevanceModal}
            setNotesData={setNotesData} handleOpenNotesModal={handleOpenNotesModal}
            setPersonName={setPersonName} getAssets={getAssets}
            setTagsData={setTagsData} handleOpenTagsModal={handleOpenTagsModal}
            setMeetResponder={setMeetResponder} handleOpenMeetModal={handleOpenMeetModal}
            handleOpenMeetConfirmModal={handleOpenMeetConfirmModal} setCurrentMeet={setCurrentMeet}
            isNewMeetingAllowed={isNewMeetingAllowed} error={error}
          />
        ))}
        {/* Claude: sentinel div — IntersectionObserver triggers next page load 25-02-2026 */}
        <Box ref={sentinelRef} h="20px" />
        {isFetchingMore && <Text fontSize="12px" color="gray.400" textAlign="center" pb={4}>Loading more...</Text>}
      </Box>
    </Box>
  );
};

export default BuyerHome;
